<!--
 * @Author: 范向玲
 * @Date: 2022-12-08 13:48:05
 * @LastEditors: chenmengnan chenmengnan@piesat.cn
 * @LastEditTime: 2024-12-25 15:55:02
 * @Description: 中资海外项目-数据管理
 * @FilePath: \web\src\components\DataManager\ChineseFundedOverseas\index.vue
-->
<template>
  <div class="chinese-funded-overseas-main">
    <div class="search-container">

      <div class="crud-wrapper" v-if="operationConf.includes(config.getPermissionId())">
        <div class="crud-item crud-item-abled" @click="goProjectManager">
          数据管理
        </div>
      </div>
    </div>

    <a-table rowKey="id" class="management-table" :dataSource="dataPages" :loading="dataPagesLoading" :columns="columns"
      @change="changePage" :scroll="{ y: '90%' }" :pagination="paginationOption">
      <!-- 表头插槽 -->
      <template #startUpYear>
        <span title="设计或实际开始年限">设计或实际开始年限</span>
      </template>
      <template #closureYear>
        <span title="设计或实际闭坑年限">设计或实际闭坑年限</span>
      </template>

      <template #serial="{ index }">{{ index + 1 }}</template>
      <template #imgUrl="{ record }">
        <img class="project-img" v-show="record.imgUrl"
          :src="imageIp + (record.imgUrl && record.imgUrl.indexOf(',') ? record.imgUrl.split(',')[0] : record.imageUrl)"
          alt="" srcset="" />
      </template>
      <!-- 产量 -->
      <template #productInfoList="{ record }">
        <span :title="getProductInfo(record.productInfoList)">{{ getProductInfo(record.productInfoList) }}</span>
      </template>
      <!-- 资源量 -->
      <template #resourceInfoList="{ record }">
        <span :title="getResourceInfo(record.resourceInfoList)">{{ getResourceInfo(record.resourceInfoList) }}</span>
      </template>

      <template #commoditiesList="{ text: commoditiesList }">
        <span :title="commoditiesList">
          <a-tag v-for="(item, index) in commoditiesList ? commoditiesList.split(',') : []" :key="index">{{ item
            }}</a-tag>
        </span>
      </template>
      <template #amtCapitalInvested="{ record }">
        <span
          :title="record.amtCapitalInvested && typeof Number(record.amtCapitalInvested) ? transMoney(fixedValue(record.amtCapitalInvested)) + '美元' : ''">{{
            record.amtCapitalInvested && typeof Number(record.amtCapitalInvested) ?
              transMoney(fixedValue(record.amtCapitalInvested)) + '美元' : '' }}</span>
      </template>

      <template #action="{ record, index }">
        <section class="action-icons">
          <i v-for="(item, i) in tableOperationList" :key="i" v-bind="item.option" @click="item.click(record, index)"
            :style="{ color: (item.option.title === '上移' && index <= 0 || item.option.title === '下移' && index === dataPages.length - 1) ? 'rgba(255, 200, 120, 0.6)' : 'rgb(255, 200, 120)', }">
          </i>
        </section>
      </template>
    </a-table>

    <Modal :option="confirmModalConf" @confirm="confirm" @close="close">
      <template v-slot:main>
        <template v-if="confirmModalConf.isEdit">
          <section style="margin-bottom:.10rem;" v-show="confirmModalConf.imageUrlList.length > 0">
            <div>项目照片：</div>
            <img :src="imageIp + item" alt="已上传图片" v-for="(item, index) in confirmModalConf.imageUrlList" :key="index"
              style="width:.86rem;margin:.05rem;object-fit:contain;">
          </section>
          <a-upload list-type="picture-card" v-model:file-list="confirmModalConf.fileList" :before-upload="beforeUpload"
            :show-upload-list="{ showPreviewIcon: false }" @change="handleChange">
            <PlusOutlined />
            <div class="ant-upload-text">上传项目照片</div>
          </a-upload>
          <!-- <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
            <img alt="example" style="width: 100%" :src="previewImage" />
          </a-modal> -->
        </template>
      </template>
    </Modal>
    <!-- / 操作弹出框 -->
  </div>
</template>

<script setup>
import { ref, reactive, computed, toRefs, watch, onMounted, onBeforeMount, } from 'vue';
import { GET_MANAGEMENT_INDUSTRY_PAGE, } from '@/store/modules/actions/dataManagement.js';
import { useStore, } from 'vuex';
import { useRouter, } from 'vue-router';
import { message, } from 'ant-design-vue';
import Modal from '@/components/lib/Modal/modal1.vue';
import config from '@/config/config';
import { imageIp, } from '@/config/index';
import { tableConfig, } from './tableConfig.js';
import { operationUpdate, operationUpdate1, } from '@/api/dataManagement/dataManage';
import { PlusOutlined, LoadingOutlined, QuestionCircleOutlined, } from '@ant-design/icons-vue';
import { getResourceInfo, getProductInfo, } from '@/components/utils/utils';
import { transMoney, fixedValue, } from '@/utils/utils';

const columns = tableConfig;

const router = useRouter();

const { state, dispatch: storeDispatch, commit: storeCommit, } = useStore();
// state
const chineseFundedOverseasState = computed(() => state.chineseFundedOverseas);
const { requestParams, dataPages, totalCount, dataPagesLoading, } = toRefs(
  chineseFundedOverseasState.value
);
// 重写commit
const commit = (space, methods, params) => storeCommit(`${space || 'chineseFundedOverseas'}/${methods}`, params);
// 重写dispatch
const dispatch = (space, methods, params) => storeDispatch(`${space || 'chineseFundedOverseas'}/${methods}`, params);

// const previewVisible = ref(false);
// const previewImage = ref('');

const selectedKeys = ref([]); // 表格选中id

const paginationOption = computed(() => ({
  total: totalCount.value,
  pageSize: requestParams.value.size,
  current: requestParams.value.page,
  showSizeChanger: true,
  showQuickJumper: true,
  pageSizeOptions: ['6', '10', '20', '30', '40', '50',],
}));

// 确认弹窗 公用
const confirmModalConf = reactive({
  loading: false,
  visible: false,
  title: '',
  confirm: null,
  callback: null,
  isEdit: false,
  width: '5.4rem',
  fileList: [],
  uploadLoading: false,
  imageUrl: '',
  imageUrlList: [],
});

/**
 * @description 检索重置事件
 */
const resetSearch = () => {

};

/**
 * @description 检索查询事件
 */
const submitSearch = () => { };

/**
 * @description 表格选中事件
 */
// const rowSelection = {
//   onChange: (selectedRowKeys, selectedRows) => {
//     selectedKeys.value = selectedRowKeys;
//   },
// };

/**
 * @description 查询
 */
const searchHandle = () => {
  dispatch(null, GET_MANAGEMENT_INDUSTRY_PAGE);
};

/**
 * @description 页码change事件
 */
const changePage = (page) => {
  commit(null, 'setRequestParams', { page: page.current, size: page.pageSize, });
  searchHandle();
};

/**
 * @description 关闭通用弹窗
 */
const close = () => {
  confirmModalConf.remark = '';
  confirmModalConf.visible = false;
  confirmModalConf.isEdit = false;
  confirmModalConf.imageUrl = '';
  confirmModalConf.imageUrlList = [];
  confirmModalConf.fileList = [];
  confirmModalConf.width = '5.4rem';
};

/**
 * @description 确认通用弹窗
 */
const confirm = () => {
  confirmModalConf.callback();
};
const getBase64 = (img, callback) => {
  const reader = new FileReader();

  reader.addEventListener('load', () => callback(reader.result));
  reader.readAsDataURL(img);
};
/* 文件改变 */
const handleChange = (info) => {
  const isJpgOrPng = info.file.type === 'image/jpeg' || info.file.type === 'image/png';

  if (!isJpgOrPng) {
    message.error('文件格式支持jpeg、png!');
  }
  const isLt2M = info.file.size / 1024 / 1024 < 5;

  if (!isLt2M) {
    message.error('文件需小于5M!');
  }

  if (isJpgOrPng && isLt2M) {
    if (info.fileList.length > 0) {
      getBase64(info.fileList.at(-1).originFileObj, base64url => {
        info.fileList.at(-1).thumbUrl = base64url;
        info.fileList.at(-1).url = base64url;
        info.fileList.at(-1).originFileObj.thumbUrl = base64url;
        info.fileList.at(-1).originFileObj.url = base64url;
      });
      confirmModalConf.fileList = [...info.fileList,];
    }
  }
};
/* 预览取消 */
// const handleCancel = () => {
//   previewVisible.value = false;
// };
/* 文件预览 */
// const handlePreview = (file) => {
//   if (!file.url && !file.preview) {
//     file.preview = getBase64(file.originFileObj);
//   }

//   previewImage.value = file.url || file.preview;
//   previewVisible.value = true;
// };
const beforeUpload = (file) => {
  return false;
};

// 跳转至矿业项目库数据管理
const goProjectManager = () => {
  router.push('/main/project/dataManagement');
};

const tableOperationList = ref([]);
// 新增 删除的权限控制
const operationConf = [1, 2,];

// 数据上移
const upRecord = (record, index) => {
  if (index <= 0) {
    console.log('已经是第一条了');
  } else {
    let updata = dataPages.value[index - 1];

    dataPages.value.splice(index - 1, 1);
    dataPages.value.splice(index, 0, updata);
  }
};
// 数据下移
const downRecord = (record, index) => {
  if (index === dataPages.value.length - 1) {
    console.log('已经是最后一条了');
  } else {
    let downdata = dataPages.value[index + 1];

    dataPages.value.splice(index + 1, 1);
    dataPages.value.splice(index, 0, downdata);
  }
};
// -------------------- 删除
// 开始删除
const delInfo = (record) => {
  record.show = 0;
  record.label = null;
  operationUpdate(record).then(res => {
    confirmModalConf.visible = false;
    searchHandle();
  });
};
// 单行数据删除之前
const beforeDel = (record) => {
  confirmModalConf.title = '是否从中资海外项目清单中移除？';
  confirmModalConf.callback = () => delInfo(record);
  confirmModalConf.visible = true;
};
// 单行删除
const delRecord = (record) => {
  beforeDel(record);
};
/* 图片上传 */
const editInfo = (record) => {
  let dataObj = new FormData();

  dataObj.append('id', record.id);
  if (confirmModalConf.fileList.length > 0) {
    for (let i = 0; i < confirmModalConf.fileList.length; i++) {
      dataObj.append('imageFiles', confirmModalConf.fileList[i].originFileObj);
    }
    operationUpdate1(dataObj).then(res => {
      confirmModalConf.visible = false;
      confirmModalConf.imageUrl = '';
      confirmModalConf.imageUrlList = [];
      confirmModalConf.fileList = [];
      searchHandle();
    });
  }
};
/* 编辑 */
const beforeEdit = (record) => {
  confirmModalConf.title = '编辑项目？';
  confirmModalConf.callback = () => editInfo(record);
  confirmModalConf.visible = true;
  confirmModalConf.isEdit = true;
  confirmModalConf.imageUrl = record.imgUrl;
  confirmModalConf.imageUrlList = record.imgUrl ? record.imgUrl.indexOf(',') ? record.imgUrl.split(',') : [record.imgUrl,] : [];
};

const editRecord = (record) => {
  beforeEdit(record);
};
// 操作的权限
const tableOperationListConf = [
  {
    option: {
      style: 'color: rgb(255, 200, 120)',
      class: 'iconfont icon-jiantou_xiangshang',
      title: '上移',
    },
    click: upRecord,
    operation: [1, 2,],
  },
  {
    option: {
      style: 'color: rgb(255, 200, 120)',
      class: 'iconfont icon-jiantou_xiangxia',
      title: '下移',
    },
    click: downRecord,
    operation: [1, 2,],
  },
  {
    option: {
      style: 'color: rgb(255, 200, 120)',
      class: 'iconfont icon-shanchu',
      title: '删除',
    },
    click: delRecord,
    operation: [1, 2,],
  },
  {
    option: {
      style: 'color: rgb(255, 200, 120)',
      class: 'iconfont icon-bianjishuru',
      title: '编辑',
    },
    click: editRecord,
    operation: [1, 2,],
  },
];

onBeforeMount(() => {
  // window.open('/pdf/024434.pdf');
  tableOperationList.value = tableOperationListConf.filter((i) => i.operation.includes(config.getPermissionId()));
  searchHandle();
});
</script>

<style lang="scss">
.chinese-funded-overseas-main {
  height: 100%;
  background: rgba(179, 150, 92, 0.05);

  /* 检索条件 */
  .search-container {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding-left: .1rem;
    height: 0.5rem;
    margin-bottom: 0.1rem;

    .search {
      display: flex;

      .search-item {
        width: 2.2rem;
        height: 0.34rem;
        margin-right: 0.05rem;
        display: flex;

        .search-item-text {
          color: #fff;
          width: 1.1rem;
          text-align: right;
          height: 0.34rem;
          line-height: 0.34rem;
        }
      }

      /* 重置、查询操作 */
      .btn-wrapper {
        height: 0.32rem;
        line-height: 0.32rem;
        margin-left: 0.2rem;
        color: #ffffff;
        display: flex;
        padding: 0;

        .btn-item {
          width: 0.9rem;
          text-align: center;
          cursor: pointer;

          &:active {
            opacity: 0.8;
          }
        }

        .reset-btn {
          // background-color: #535962;
          background-image: url(~@/static/images/dataManagement/reset_btn.png);
          background-size: 100% 100%;
        }

        .search-btn {
          margin-left: 0.05rem;
          // background-color: #efb227;
          background-image: url(~@/static/images/dataManagement/submit_btn.png);
          background-size: 100% 100%;
        }
      }

      /* 输入框 */
      .ant-input {
        color: white;
        background-color: rgba(91, 76, 39, 0.4);
        font-size: 0.14rem;
        font-family: Microsoft YaHei;
        border: transparent;
      }

      .ant-input-suffix {
        width: 0.12rem;
        height: 0.12rem;
        margin-top: .02rem;
      }

      /** 下拉框 */
      .ant-select {
        width: 100%;
        height: 100%;

        .ant-select-selector {
          height: 100%;
        }

        .ant-select-arrow {
          color: #fff;
        }

        .ant-select-selection-item {
          line-height: .34rem;
        }

        // 背景
        &:not(.ant-select-customize-input) .ant-select-selector {
          background-color: rgba(91, 76, 39, 0.4);
          border: none;
          color: #fff;
        }

        /* 描述 */
        .ant-select-selection-placeholder {
          line-height: .34rem;
          color: #fff;
        }
      }
    }

    /* 增删改导按钮 */
    .crud-wrapper {
      display: flex;
      height: 0.51rem;
      padding: 0.13rem 0.1rem;

      .crud-item {
        margin-right: 0.04rem;
        width: 0.7rem;
        line-height: .25rem;
        color: #fff;
        // background-color: #efb227;
        background-image: url(~@/static/images/dataManagement/curd_btn.png);
        background-size: 100% 100%;
        text-align: center;
      }

      .crud-item:hover {
        cursor: pointer;
      }

      .crud-item-disabled {
        pointer-events: none;
        color: rgba(255, 255, 255, 0.6);
        // background-color: rgba(239, 178, 39, 0.6);
        opacity: 0.8;
      }

      .crud-item-disabled:hover {
        cursor: no-drop;
      }
    }
  }

  /* 矿种图标 */
  .minerals-img {
    width: 0.6rem;
    height: 0.3rem;
  }

  
  /* 表格样式 */
  .management-table {
    height: calc(100% - 0.5rem);

    .ant-spin-container {
      display: flex;
      flex-direction: column;
      align-items: end;
    }

    .ant-spin-nested-loading,
    .ant-spin-container,
    .ant-table-content {
      height: 100%;
    }

    .ant-table {
      height: calc(100% - .70rem);
      background: none;
      padding-left: 0.1rem;

      .ant-table-scroll {
        height: 100%;
        overflow: visible;
        overflow-x: visible;

        .ant-table-header {
          overflow: visible !important;
          margin-bottom: 0 !important;
        }
      }

      .ant-table-header {
        background: none;
      }

      .ant-table-body {
        overflow-x: hidden !important;
        overflow-y: auto !important;
        background: none;
      }

      /* 项目照片 */
      .project-img {
        width: 0.8rem;
        height: 0.6rem;
      }

      /* 矿种 */
      .primary-commodity-img {
        width: 0.8rem;
        height: 0.6rem;
      }

      /* 图标 */
      .action-icons {
        display: flex;

        i {
          font-size: 0.22rem;
          margin-right: 0.04rem;
          cursor: pointer;
        }

        .crud-wrapper {
          display: flex;
          height: 0.25rem;
          padding: 0 0.1rem;
          margin-top: 0.05rem;

          .crud-item {
            margin-right: 0.04rem;
            width: 0.7rem;
            line-height: .25rem;
            color: #fff;
            // background-color: #efb227;
            background-image: url(~@/static/images/dataManagement/curd_btn.png);
            background-size: 100% 100%;
            text-align: center;
          }

          .crud-item:hover {
            cursor: pointer;
          }

          .crud-item-disabled {
            pointer-events: none;
            color: rgba(255, 255, 255, 0.6);
            // background-color: rgba(239, 178, 39, 0.6);
            opacity: 0.8;
          }

          .crud-item-disabled:hover {
            cursor: no-drop;
          }
        }
      }

      .ant-table-thead {
        border: .01rem solid #4d3f1c;
        border-radius: .10rem .10rem 0rem 0rem;
        background: none;
      }

      .ant-table-thead>tr>th {
        color: #dccdab;
        background: rgba(179, 150, 92, 0.2);
        border: none;
      }

      .ant-table-tbody>tr>td {
        background-color: transparent;
        color: #fff;
        border-bottom: .01rem solid rgba(179, 150, 92, 1);
        vertical-align: middle;
      }

      .ant-table-placeholder {
        height: 100%;
        background-color: rgba(77, 63, 28, 1);
        border-top: rgba(179, 150, 92, 1);
        border-bottom: rgba(179, 150, 92, 1);
      }

      .ant-empty-normal {
        color: rgba(179, 150, 92, 1);
      }

      // 暂无数据填充样式
      // .ant-empty-img-simple-path {
      //   fill: rgba(77, 63, 28, 1);
      // }
      // .ant-empty-img-simple-ellipse {
      //   fill: rgba(77, 63, 28, 1);
      // }
      .ant-table-thead>tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)>td,
      .ant-table-tbody>tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)>td,
      .ant-table-thead>tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)>td,
      .ant-table-tbody>tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)>td {
        background-color: rgba(179, 150, 92, 0.6);
      }

      .ant-table-thead>tr:hover.ant-table-row-selected>td,
      .ant-table-tbody>tr:hover.ant-table-row-selected>td {
        background-color: rgba(179, 150, 92, 0.6);
      }

      .ant-table-tbody>tr.ant-table-row-selected td {
        background-color: rgba(77, 63, 28, 1);
        color: #fff;
      }
    }
  }

  .avatar-uploader>.ant-upload {
    width: 1.28rem;
    height: 1.28rem;
  }

  .ant-upload-select-picture-card i {
    font-size: .32rem;
    color: #999;
    background-color: #5B4C27;
  }

  .ant-upload-select-picture-card .ant-upload-text {
    margin-top: .08rem;
    color: #FFF;
    background-color: #5B4C27;
  }

  .ant-upload.ant-upload-select-picture-card {
    background-color: #5B4C27;
  }

  .ant-upload-picture-card-wrapper {
    color: red;
  }

  .ant-upload .ant-upload-select .ant-upload-select-picture-card {
    background-color: #5B4C27;
  }

  // .ant-upload-picture-card-wrapper {
  //   .ant-upload .ant-upload-select-picture-card {
  //     background-color: #5B4C27;
  //     border: 1px dashed #C5A675;
  //   }
  //   .ant-upload {
  //     color: #fff;
  //   }
  // }
}
</style>
